/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Requests_Title_OrganizationInputs */



/**
* | output |
* | --- |
* | "Organization Requests" |
*
* @param {Dashboard_Requests_Title_OrganizationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_requests_title_organization = /** @type {((inputs?: Dashboard_Requests_Title_OrganizationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Requests_Title_OrganizationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisationsanfragen")
	return /** @type {LocalizedString} */ ("Organization Requests")
});